/** Shared category header title box (TILDA layers + static datasets). */
export const categoryHeaderTitleBoxClassName =
  'flex min-h-10 min-w-0 flex-col items-start py-2 pl-2 text-sm leading-4.25'
